module.exports = __webpack_public_path__ + "assets/img/report.5f829e2f.svg";